// extracted by mini-css-extract-plugin
export default {"toasts":"Recovery_toasts__Ft+us"};